import { observable, configure, action } from 'mobx';
import util from 'preact-util';

configure({ enforceActions: 'always' });

class InsuranceCompanyStore {
    @observable companies = [];

    @action
    updateKeyValue(key, value) {
        this[key] = value;
    }

    @action
    async loadAll() {
        if (this.companies && this.companies.length > 0) {
            return this.companies;
        }
        const response = await util.fetchApi('/api/insurance-companies', { method: 'GET' }, {});
        if (response && response.status === 200) {
            this.updateKeyValue('companies', response.data || []);
        }
        return this.companies;
    }

    getById(id) {
        if (!id) return null;
        const key = String(id).toLowerCase().trim();
        return this.companies.find(c => c && c.id === key) || null;
    }
}

const store = new InsuranceCompanyStore();
export default store;
